import React from 'react';
import { Typography, Box} from '@mic3/platform-ui';

import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { name, label } from 'app/utils/designer/form/settings/common/commonBase';
import { onLoad, onChange, isVisible, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import QueryBuilder from 'app/components/Designer/QueryBuilder/QueryBuilder';
import AddEntitityAttributes from 'app/components/Designer/AddEntitityAttributes/AddEntitityAttributes';
import Help from 'app/utils/designer/form/settings/common/Help';
import { pick } from 'app/utils/lo/lo';

const panels = (settingValues) => {
    return [
        {
            header: 'Base',
            // expanded: true,
            children: [
                name,
                label,
                { type: 'divider' },
                {
                    type: 'entityTypesTypeahead',
                    properties: {
                        label: `Entity type`,
                        name: `properties.entityType`,
                        onChange: (evnt) => {
                            return [
                                {
                                    ...evnt.target,
                                    value: evnt.target.value
                                        ? pick(evnt.target.value, ['id', 'name', 'uri'])
                                        : null,
                                },
                            ];
                        },
                    },
                    constraints: { required: true },
                },
                {
                    type: 'custom',
                    properties: {
                        label: 'Filter entities',
                        name: 'properties.filterEntitiesBy',
                        Component: QueryBuilder,
                        help: <Help message="Defines the GraphQL query filterBy parameter" />,
                    },
                },
                { type: 'divider' },
                {
                    type: 'checkbox',
                    properties: {
                        name: 'properties.isDynamicList',
                        label: 
                        <Box style={{marginBottom: '10px'}}>
                            <Typography style={{fontSize: '14px' }}>Dynamic list</Typography>
                            <Typography style={{fontSize: '12px' }}>
                                Listed entities are determined by filtering. The user cannot directly add or remove entities.
                            </Typography>
                        </Box>
                    
                    },
                },
            ],
        },
        {
            header: 'Card Attributes',
            expanded: true,
            children: [
                {
                    type: 'custom',
                    properties: {
                        parentName: settingValues?.properties?.name,
                        name: 'properties.entityAttributes',
                        entityType: settingValues?.properties?.entityType?.uri,
                        relatedEntity: settingValues?.properties?.relatedEntity,
                        relatedEntityDefinition: settingValues?.properties?.relatedEntityDefinition,
                        noBackground: true,
                        Component: AddEntitityAttributes,
                        onChange: (evnt) => {
                            return [
                                { name: 'properties.relatedEntity', value: evnt.target.value.relatedEntity },
                                { name: 'properties.relatedEntityDefinition', value: evnt.target.value.relatedEntityDefinition },
                                { name: 'properties.entityAttributes', value: evnt.target.value.attributesList },
                            ];
                        },
                    },
                },
            ],
        },
        {
            header: 'Actions',
            expanded: true,
            children: [
                {
                    type: 'groupRepeat',
                    properties: {
                        label: 'Actions',
                        name: 'properties.actions',
                        addButtons: true,
                        emptyOnLoading: true,
                        avoidValidation: false,
                    },
                    children: [
                        { 
                            type: 'text',
                            properties: { name: 'label', label: 'Label' },
                            constraints: { required: true }
                        },
                        { type: 'iconSelect', properties: { name: 'icon', label: 'Icon' } },
                        {
                            type: 'scriptTypeahead',
                            properties: { name: 'script', label: 'Script' },
                            constraints: { required: true }
                        },
                    ],
                    constraints: {
                        custom: (props) => {
                            if (props?.properties?.actions?.length && props?.properties?.actions.find((a) => !a.label && !a.script)) {
                                return {
                                    format: {
                                        pattern: /somefaketest/,
                                        message: 'Label and Script is required.',
                                    },
                                };
                            }
                            if (props?.properties?.actions?.length && props?.properties?.actions.find((a) => !a.label)) {
                                return {
                                    format: {
                                        pattern: /somefaketest/,
                                        message: 'Label is required.',
                                    },
                                };
                            }                            
                            if (props?.properties?.actions?.length && props?.properties?.actions.find((a) => !a.script)) {
                                return {
                                    format: {
                                        pattern: /somefaketest/,
                                        message: 'Script is required.',
                                    },
                                };
                            }

                            return {};
                        },
                    },
                },
            ],
        },
        {
            header: 'Events',
            children: [onLoad, onChange, isVisible, isDisabled],
        },
        {
            header: 'Helpers',
            children: [help],
        },
    ];
};

export default {
    defaults: {filterEntitiesBy: [], serialize: true, actions: [], isDynamicList: false },
    panels: settingValues => panels(settingValues),
};
